<template>
  <section class="slider-module">
    <agile :nav-buttons="false" v-if="content.slider.length">
      <div class="slide" v-for="(item, idx) in content.slider" :key="'slide' + idx">
        <figure>
          <img :src="item.directus_files_id.data.full_url" alt />
          <figcaption v-html="item.directus_files_id.description"></figcaption>
        </figure>
      </div>
    </agile>
  </section>
</template>


<script>
export default {
  props: {
    content: {
      type: Object
    }
  }
};
</script>